/**
 * ButtonsLayout.tsx - Button Bar Layout for SectionNav
 * 
 * Uses existing ButtonBar component from Phase 1
 * 
 * CHANGE HISTORY:
 * - 251115_1807 [current] danielbeer: Created buttons layout using ButtonBar
 */

import React, { useMemo } from 'react';
import { ButtonBar } from '../../ButtonBar/ButtonBar';
import type { SectionLayoutProps } from '../types';
import type { ButtonConfig } from '../../ButtonBar/types';

export const ButtonsLayout: React.FC<SectionLayoutProps & { appName: string }> = ({
  sections,
  activeSection,
  onSectionClick,
  appName
}) => {
  // Convert sections to button configs
  const buttons = useMemo<ButtonConfig[]>(() => {
    return sections.map(section => ({
      id: section.id,
      label: section.label,
      icon: section.icon,
      badge: section.badge,
      disabled: section.disabled,
      onClick: () => onSectionClick(section),
      tooltip: section.description,
      className: section.className
    }));
  }, [sections, onSectionClick]);
  
  return (
    <div className="section-nav-buttons">
      <ButtonBar
        appName={appName}
        buttons={buttons}
        activeButton={activeSection}
      />
    </div>
  );
};

ButtonsLayout.displayName = 'ButtonsLayout';
